import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete } from "@mui/material";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
// import MaterialTable from "material-table";
import _ from "lodash";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
// import uiUtils from "../../../provider/UiUtils";
import Utils from "../../../provider/Utils";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import { ApDomainList_Url, ApRegistrationList_Url } from "../../../provider/ServiceUrl";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Col, Row } from "reactstrap";
import TextField from "@material-ui/core/TextField";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import AdminPaginationRowAction from "../../../redux/adminPanel/paginationRow/AdminPaginationRowAction";
import Pagination from "../../givBee/pagination/Pagination";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

class AdminRegistrationList extends Component {
  header = store.getState().adminHeader.adminHeader;
  adminAccountState = store.getState().applicationState.adminAccountState;
  adminPaginationState = store.getState().adminPaginations.accountsState;
  title = "Accounts List";
  breadCrumb = [{ pageid: "", uiname: "Accounts List" }];
  adminAccountStateDetails = {};
  adminPaginationStateDetails = {};
  constructor() {
    super();
    if (this.adminAccountState) {
      this.adminAccountStateDetails = Object.getOwnPropertyNames(
        this.adminAccountState
      );
    }
    if (this.adminPaginationState) {
      this.adminPaginationStateDetails = Object.getOwnPropertyNames(
        this.adminPaginationState
      );
    }

    if (this.adminAccountStateDetails.length > 0) {
      this.state = {
        companyName: "",
        searchBy: this.adminAccountState.searchBy,
        businessDomainName: this.adminAccountState.businessDomainName,
        pageNo: this.adminAccountState.pageNo,
        pageSize: this.adminAccountState.pageSize,
        searchText: this.adminAccountState.searchText,
        appUserList: [],
        businessDomainList: [],
        originalAccountList: [],
        businessDomain: null,
        isPaging: false,
        render: false,
        getCreatePermission: false,
        accountStatusOpen: false,
        accountId: this.adminAccountState.accountId,
      };
    } else {
      this.state = {
        accountId: "",
        searchText: "",
        businessDomainName: "",
        companyName: "",
        searchBy: "All",
        accountList: [],
        businessDomainList: [],
        originalAccountList: [],
        businessDomain: null,
        pageNo: 0,
        pageSize:
          this.adminPaginationStateDetails?.length > 0
            ? this.adminPaginationState?.pageSize
            : 20,
        isPaging: false,
        getCreatePermission: false,
        accountStatusOpen: false,
        render: false,
        sortColumn: null,
        isAscSort: false,
        sortDirection: "asc",
      };
    }
    this.getRegistrationsList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
    this.debouncedSearch = _.debounce(this.getRegistrationsList, 800);
  }

  componentDidMount() {
    this.getBusinessDomainList();
  }

  getBusinessDomainList() {
    const postObject = {
      header: this.header,
    };

    AdminFetchServerData.callPostService(ApDomainList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {

          let businessDomainList = output.data.businessDomainList || [];

          businessDomainList.unshift({
            description: "All",
            name: "All",
            displaySequence: 0,
            id: 0
          });

          let businessDomain =
            this.state.businessDomain !== null
              ? this.state.businessDomain
              : businessDomainList[0];

          this.setState({
            businessDomainList: businessDomainList,
            businessDomain: businessDomain,
          });

        } else {
        }
      }
    );
  }


  getRegistrationsList(pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      businessDomainName: this.state.businessDomainName,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    AdminFetchServerData.callPostService(
      ApRegistrationList_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let accountList = output.data.accountList;
        let page = output.data.page;
        for (let i = 0; i < accountList.length; i++) {
          accountList[i].createdon = accountList[i].createdon !== null
            ? Utils.getUtcToLocal(accountList[i].createdon)
            : ""
        }

        let isPaging = false;
        if (accountList.length > 20) {
          isPaging = true;
        }
        this.setState({
          render: true,
          pageNo: page.pageNo,
          showPerPage: page.pageSize,
          totalPages: page.totalPages,
          totalRecords: page.total,
          isPaging: isPaging,
          accountList: accountList,
          originalAccountList: accountList,
        });
      } else {
      }
    });
  }
  deleteAccountToBackend(data) {
    this.setState({ accountStatusOpen: true, accountId: data.id, companyName: data.tenantName, accountStaus: data?.status });
  }
  toRegistrationDetails(e, data) {
    if (e.target.closest(".action-button")) {
      return;
    }
    if (data.status === "InComplete") {
      this.setState({ accountStatusOpen: false, accountId: data.id });
    } else {
      let adminAccountState = {
        accountId: data.id,
        searchText: this.state.searchText,
        searchBy: this.state.searchBy,
        businessDomainName: this.state.businessDomainName,
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      };
      store.dispatch(
        ApplicationStateAction.setApplicationState({ adminAccountState })
      );
      this.props.navigate("/viewAccount", {
        state: {
          action: "view",
          accountId: data.id,
        },
      });
    }
  }

  handleMaterialTablePageChange(page, pageSize) {
    let accountsState = {
      pageNo: page,
      pageSize: pageSize,
    };
    store.dispatch(
      AdminPaginationRowAction.setAccountsPaginationState({ accountsState })
    );
    this.setState({ pageNo: page, pageSize: pageSize });
  }

  handleAccountStatusClose = () => {
    this.setState({
      accountStatusOpen: false,
      password: "",
    });
  };

  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  deleteAccountInBackend() {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.accountId,
      },
      credential: this.state.password,
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/deleteIncomplete",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.getRegistrationsList(this.state.pageNo,
          this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
        this.setState({
          render: true,
          accountStatusOpen: false,
          password: "",
        });
      } else {
      }
    });
  }

  handleSearchChange(searchText) {
    let adminAccountState = {
      accountId: this.state.accountId,
      searchText: searchText,
      searchBy: this.state.searchBy,
      businessDomainName: this.state.businessDomainName,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ adminAccountState })
    );
    this.setState({ searchText: searchText });
  }

  handleBusinessDomainChange = (selectedDomain) => {
    let filteredList = [];

    if (selectedDomain.id === 0) {
      filteredList = this.state.originalAccountList;
    } else {
      filteredList = this.state.originalAccountList.filter(
        item => item.businessDomainid?.toString() === selectedDomain.id?.toString()
      );
    }

    this.setState({
      businessDomain: selectedDomain,
      accountList: filteredList,
      isPaging: filteredList.length > 20
    });
  };

  // handleSearchByChange = ({ target: { value } }) => {
  //   console.log(value)
  //   const { originalAccountList } = this.state;
  //   let filteredList = [];
  //   console.log(originalAccountList)
  //   switch (value) {
  //     case "All":
  //       filteredList = originalAccountList;
  //       break;

  //     case "GivBeeMain":
  //     case "EventText":
  //     case "DPText":
  //       filteredList = originalAccountList.filter(
  //         item => item?.businessDomain === value
  //       );
  //       break;

  //     default:
  //       filteredList = originalAccountList;
  //   }

  //   this.setState({
  //     searchBy: value,
  //     accountList: filteredList,
  //     isPaging: filteredList.length > 20,
  //   });
  // };

  handleSearchByChange = ({ target: { value } }) => {
    let adminAccountState = {
      accountId: this.state.accountId,
      searchText: this.state.searchText,
      searchBy: this.state.searchBy,
      businessDomainName: value !== "All" ? value : "",
      pageNo: 0,
      pageSize: 20,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ adminAccountState })
    );
    this.setState(
      { searchBy: value, businessDomainName: value !== "All" ? value : "" },
      () => {
        this.getRegistrationsList(
          0,
          20,
        );
      }
    );
  };

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    this.getRegistrationsList(currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort);
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }

  removeSearchChange() {
    let adminAccountState = {
      accountId: this.state.accountId,
      searchText: "",
      searchBy: this.state.searchBy,
      businessDomainName: this.state.businessDomainName,
      pageNo: 0,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ adminAccountState })
    );

    this.setState({ searchText: "", pageNo: 0 }, () => {
      this.getRegistrationsList(0, this.state.pageSize);
    });
  }

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort,
      },
      () => {
        this.getRegistrationsList(pageNo, pageSize, column, isAscSort);
      }
    );
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          name={this.title}
          isSearchText={this.state.searchText !== ""}
        />

        <div className="row">
          <div className="col md-12">
            <div className="card rounded-0">
              <div
                className="row justify-content-between"
                style={{ padding: "0.6em 1.2rem" }}
              >
                <div className="col-md-8 d-flex align-items-center">
                  <label
                    className="mb-1 fw-bold me-2"
                    style={{ lineHeight: "1.2", fontSize: "14px", width: "90px" }}
                  >
                    Search by:
                  </label>
                  <RadioGroup
                    row
                    value={this.state.searchBy}
                    onChange={this.handleSearchByChange}
                    sx={{
                      alignItems: "center",
                      "& .MuiFormControlLabel-root": {
                        alignItems: "center",
                      },
                    }}
                  >
                    <FormControlLabel
                      value="All"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 14 },
                          }}
                        />
                      }
                      label="All"
                      sx={{
                        gap: "2px",
                        mr: 3,
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          lineHeight: "1.2",
                        },
                      }}
                    />
                    <FormControlLabel
                      value="GivBee"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 14 },
                          }}
                        />
                      }
                      label="GivBee"
                      sx={{
                        gap: "2px",
                        mr: 3,
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          lineHeight: "1.2",
                        },
                      }}
                    />
                    <FormControlLabel
                      value="EventText"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 14 },
                          }}
                        />
                      }
                      label="EventText"
                      sx={{
                        gap: "2px",
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          lineHeight: "1.2",
                        },
                      }}
                    /> &nbsp;&nbsp;
                    <FormControlLabel
                      value="DPText"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 14 },
                          }}
                        />
                      }
                      label="DPText"
                      sx={{
                        gap: "2px",
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          lineHeight: "1.2",
                        },
                      }}
                    />
                  </RadioGroup>
                </div>
                <div className="d-flex col-12 col-lg-4 col-xl-4 text-end align-self-center">
                  <div className="col-sm-12 text-end align-self-center">
                    <span className="me-1">
                      <TextField
                        id="adminStandard-search"
                        placeholder="Search"
                        type="text"
                        variant="standard"
                        style={{ width: "193px" }}
                        value={this.state.searchText}
                        onChange={this.onSearchChange.bind(this)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                onClick={this.getRegistrationsList.bind(
                                  this,
                                  this.state.pageNo,
                                  this.state.pageSize,
                                )}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={this.removeSearchChange.bind(this)}
                                disabled={!this.state.searchText}
                              >
                                <ClearIcon
                                  style={{
                                    opacity: this.state.searchText
                                      ? 1
                                      : 0.4,
                                    fontSize: "1.25rem",
                                    color: "353538",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="table-responsive adminPaginationTable">
                <table className="table text-start table-hover">
                  <thead className="adminPaginationTableThead">
                    <tr>
                      <th scope="col fw-bold">#</th>
                      <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("tenantName")}
                      >
                        Company Name
                        {this.state.sortColumn === "tenantName" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th
                        scope="col fw-bold"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSort("userName")}
                      >
                        User Name
                        {this.state.sortColumn === "userName" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th
                        className="cursor-pointer"
                        scope="col fw-bold"
                        onClick={() => this.handleSort("userEmail")}
                      >
                        User ID
                        {this.state.sortColumn === "userEmail" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("businessDomain")}>Domain
                        {this.state.sortColumn === "businessDomain" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("createdon")}>Created On
                        {this.state.sortColumn === "createdon" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("status")}>Status
                        {this.state.sortColumn === "status" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("lastLoginDate")}>Last Login
                        {this.state.sortColumn === "lastLoginDate" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th scope="col fw-bold">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.accountList?.map((rowData, index) => (
                      <tr
                        className="cursor-pointer"
                        key={index}
                        style={{
                          backgroundColor:
                            rowData.id === this.state.accountId
                              ? "#FEF5E7"
                              : "",
                        }}
                      >
                        <td style={{ width: "60px" }}> {this.state.pageNo * this.state.pageSize + index + 1}</td>
                        <td
                          style={{ width: "210px" }}
                          onClick={(e) =>
                            this.toRegistrationDetails(e, rowData, index)
                          }
                        >
                          {rowData.donarClientId != null
                            ? `${rowData.tenantName} (${rowData.donarClientId})`
                            : rowData.tenantName}
                        </td>
                        <td
                          style={{ width: "170px" }}
                          onClick={(e) =>
                            this.toRegistrationDetails(e, rowData, index)
                          }
                        >
                          {rowData.userName}
                        </td>
                        <td
                          style={{ width: "250px" }}
                          onClick={(e) =>
                            this.toRegistrationDetails(e, rowData, index)
                          }
                        >
                          <>
                            <a
                              href={`mailto:${rowData.userEmail}`}
                              className="anchortag me-1"
                              title="Send Email"
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <EmailOutlinedIcon style={{ fontSize: "18px", verticalAlign: "middle" }} />
                            </a>
                            {rowData.userEmail}
                          </>
                        </td>
                        <td
                          style={{ width: "120px" }}
                          onClick={(e) =>
                            this.toRegistrationDetails(e, rowData, index)
                          }
                        >
                          {rowData.businessDomain}
                        </td>
                        <td
                          style={{ width: "130px" }}
                          onClick={(e) =>
                            this.toRegistrationDetails(e, rowData, index)
                          }
                        >
                          {rowData.createdon} &nbsp; {rowData?.isMigrated === true && "(-m)"}
                        </td>
                        <td
                          style={{ width: "80px" }}
                          onClick={(e) =>
                            this.toRegistrationDetails(e, rowData, index)
                          }
                        >
                          {rowData.status}
                        </td>
                        <td
                          style={{ width: "110px" }}
                          onClick={(e) => this.toRegistrationDetails(e, rowData, index)}
                        >
                          {(() => {
                            if (!rowData.lastLoginDate) return "";

                            const lastLogin = new Date(rowData.lastLoginDate);
                            const now = new Date();
                            const diffDays = Math.floor(
                              (now - lastLogin) / (1000 * 60 * 60 * 24)
                            );

                            const formattedDate = Utils.getUtcToLocal(rowData.lastLoginDate);

                            return (
                              <span
                                style={{
                                  color: diffDays > 60 ? "#990000" : "inherit",
                                  fontWeight: diffDays > 60 ? "bold" : "normal",
                                }}
                              >
                                {formattedDate}
                              </span>
                            );
                          })()}
                        </td>
                        <td
                          key={rowData.id}
                          style={{ width: "80px", textAlign: "center", verticalAlign: "middle" }}
                        >
                          {["InComplete", "Delete Requested"].includes(rowData.status) && (
                            <i
                              className="fa-regular fa-trash-can"
                              aria-hidden="true"
                              style={{
                                borderRadius: "25%",
                                color: "#6A7B8E",
                                fontSize: "18px",
                                width: "30px",
                                height: "30px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                fontWeight: "600",
                              }}
                              onClick={() => this.deleteAccountToBackend(rowData)}
                              title="Delete Account"
                            ></i>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {this.state.totalRecords === 0 && (
                <div
                  className="row text-center"
                  style={{ padding: "6px 20px" }}
                >
                  <h5 className="dataNotAvailable">
                    No results found
                  </h5>
                </div>
              )}
              {this.state.totalRecords > 10 && (
                <div className="row justify-content-between pagination p-1">
                  <div className="d-flex col-12 col-lg-4 col-xl-4">
                    <div className="pageSize col-12 text-start">
                      Total: {this.state.totalRecords}
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-8 col-xl-8">
                    <div className="col-12 text-end">
                      <Pagination
                        showPerPage={this.state.showPerPage}
                        onPaginationChange={this.onPaginationChange.bind(
                          this
                        )}
                        total={this.state.totalRecords}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div >

        <Dialog
          open={this.state.accountStatusOpen}
          onClose={this.handleAccountStatusClose.bind(this)}
          onHide={this.close}
          style={{ padding: "1em" }}
        >
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.deleteAccountInBackend.bind(this)}
          >
            <DialogContent style={{ width: "502px" }}>
              <span style={{ textAlign: "center" }}>
                <p style={{ fontSize: "17px", lineHeight: "1.3em" }}>
                  {this.state.accountStaus === "InComplete" ? "You are deleting this account as payment is incomplete." : `${this.state.companyName} has requested to delete their account.`}
                </p>
              </span>
              <div>
                <span style={{ textAlign: "center" }}>
                  <h2 style={{ fontSize: "17px" }}>
                    Please enter your Password{" "}
                  </h2>
                </span>
                <Row>
                  <Col
                    md={6}
                    style={{ marginLeft: "auto", marginRight: "auto" }}
                  >
                    <TextField
                      title=""
                      variant="outlined"
                      // margin="normal"
                      size="small"
                      required
                      fullWidth
                      name="password"
                      type={this.state.showPassword ? "text" : "password"}
                      id="password"
                      autoFocus={true}
                      autoComplete="off"
                      onChange={this.handlePasswordChange.bind(this)}
                      value={this.state.password}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={this.handleClickShowPassword.bind(this)}
                            >
                              {this.state.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Col>
                </Row>
              </div>
            </DialogContent>
            <DialogActions
              className="justify-content-center"
              style={{
                padding: "2em",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="contained"
                size="large"
                type="submit"
                style={{
                  background: "#0B6F9D",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<SaveIcon />}
              >
                Confirm
              </Button>
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<CloseIcon />}
                onClick={this.handleAccountStatusClose.bind(this)}
              >
                Cancel
              </Button>
            </DialogActions>
          </ValidatorForm>
        </Dialog>
      </>
    );
  }
}
export default withRouter(AdminRegistrationList);
